import { Component, OnInit, Input } from '@angular/core';
import { faStar, faStarHalf, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { faStar as faEmptyStar } from "@fortawesome/free-regular-svg-icons";

@Component({
  selector: 'app-star-ratings',
  templateUrl: './star-ratings.component.html',
  styleUrls: ['./star-ratings.component.css']
})
export class StarRatingsComponent implements OnInit {
  @Input() rating: number;
  @Input() count: number;
  @Input() showOneStar: boolean = false;
  @Input() showRating: boolean = true;
  @Input() large: boolean = false;
  @Input() onlyStars: boolean = false;

  fullStarIcon = faStar;
  halfStarIcon = faStarHalf;
  emptyStarIcon = faEmptyStar;

  constructor() { }

  ngOnInit(): void {
  }

  determineIcon(value: number): IconDefinition {
    if (this.rating > (value - 1) && this.rating < value) {
      return this.halfStarIcon;
    } else if (this.rating >= value) {
      return this.fullStarIcon;
    } else {
      return this.emptyStarIcon;
    }
  }

}
